import React from 'react';
import PropTypes from 'prop-types';
import PatternLibModalComponent from './modals/PatternLibModalComponent';

class ErrorPopUpComponent extends React.Component {
  constructor(props) {
    super(props);
    this.errorBody = this.errorBody.bind(this);
  }

  errorBody() {
    return (
      <div className="modal_content error-popup">
        <p>
          <strong>{this.props.error.message}</strong>
        </p>
      </div>
    );
  }

  render() {
    return (
      <PatternLibModalComponent
        customClass={'c-modal c-modal--center'}
        show
        modalHeading={''}
        onHide={this.props.closeErrorPopup}
        bsSize={'medium'}
        modalFooter={
          <button
            className="c-btn c-btn--default c-modal__button"
            onClick={this.props.closeErrorPopup}
          >
            {this.props.content.ok}
          </button>
        }
        modalBody={this.errorBody()}
        modalInContainer={false}
        closeButton
      />
    );
  }
}

ErrorPopUpComponent.propTypes = {
  content: PropTypes.object,
  error: PropTypes.object,
  closeErrorPopup: PropTypes.func,
};
ErrorPopUpComponent.defaultProps = {
  content: { ok: 'OK' },
  error: {
    message: 'Something went wrong',
    quoteId: '',
  },
};
export default ErrorPopUpComponent;
